// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__1s-3l","footerContainer__list":"Footer_footerContainer__list__3sEa1","footerContainer__item":"Footer_footerContainer__item__1jfgh"};